import { memo, useState } from "react";
import { trackEvent } from "@leafly-com/web-utils";
import capitalize from "lodash/capitalize";

import TrackImpression from "components/TrackImpression";

import CityCard from "./CityCard";
import Tab from "./Tab";
import Tabs from "./Tabs";

export type Filter = "all" | "medical" | "recreational";

export type City = {
  city: string;
  count: number;
  distance: number;
  distanceUnit: string;
  state: string;
};

type Props = {
  heading?: string;
  subheading?: string;
  cities: City[];
  showFilterTabs: boolean;
  handleFilterCities: (filter: Filter) => void;
};

const CitiesNearby = ({
  heading,
  subheading,
  cities,
  showFilterTabs = true,
  handleFilterCities,
}: Props) => {
  const filterItems: Filter[] = ["all", "recreational", "medical"];

  const [activeFilter, setActiveFilter] = useState<Filter>("all");

  const handleClick = (filter: Filter) => {
    setActiveFilter(filter);
  };

  return (
    <div className="cities-nearby container my-xxl">
      {heading && (
        <TrackImpression category="Cities Near You" label="Cities Near You">
          <h2 className="mb-sm" data-testid="cities-nearby-heading">
            {heading}
          </h2>
        </TrackImpression>
      )}
      {subheading && (
        <p
          className="section-subheading text-xs"
          data-testid="cities-nearby-subheading"
        >
          {subheading}
        </p>
      )}
      {showFilterTabs && (
        <Tabs data-testid="cities-nearby-filters">
          {filterItems.map((filter, idx) => (
            <Tab
              node={capitalize(filter)}
              key={idx}
              isActive={activeFilter === filter}
              handleClick={() => {
                handleClick(filter as Filter);
                handleFilterCities(filter);
                trackEvent(
                  "Cities Near You",
                  "Click",
                  `Online Ordering ${capitalize(filter)}`
                );
              }}
            />
          ))}
        </Tabs>
      )}
      <div className="cityGrid">
        {cities.map((city, idx) => (
          <CityCard
            data={city}
            filter={activeFilter}
            key={idx}
            extraClasses="elevation-low"
          />
        ))}
      </div>
      <style jsx>{`
        .cityGrid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-gap: 8px;
        }
      `}</style>
    </div>
  );
};

export default memo(CitiesNearby);
